import { render } from "./iconRefresh.vue?vue&type=template&id=0bc38906"
import script from "./iconRefresh.vue?vue&type=script&lang=js"
export * from "./iconRefresh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__